import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextToSpeach: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextToSpeach"><Path fillRule="evenodd" clipRule="evenodd" d="M15.0044 7V21H13.0044V7H15.0044ZM18.5044 10V18H16.5044V10H18.5044ZM22.0044 12V16H20.0044V12H22.0044ZM11.5044 14V18H9.50439V14H11.5044Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2.00439 3H12.0044V6.77778H10.0044V5H8.00439V11H9.33773V13H4.67106V11H6.00439V5H4.00439V6.77778H2.00439V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextToSpeach;
